import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { useDraft } from 'src/app/v1/views/hooks/useDraft';
import { useJobLocation } from 'src/app/v1/views/hooks/useJobLocation';
import { useQuestionnaire } from 'src/app/v1/views/hooks/useQuestionnaire';
import type { AppState } from 'src/types/appState';

export const useEditDraft = () => {
  const {
    advertiserId,
    seekAdvertiserId,
    hasDraftDataLoaded,
    isDataCleanupComplete,
    queryParamsDraftId,
    questionnaireUrl,
  } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      seekAdvertiserId: state.session.seekAdvertiserId,
      hasDraftDataLoaded: state.app.withDraftId.hasLoaded,
      isDataCleanupComplete: state.app.isDataCleanupComplete,
      queryParamsDraftId: state.app.queryParams.draftid,
      questionnaireUrl: state.formData.questionnaireUrl,
    }),
    shallowEqual,
  );

  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();

  const { getDraft } = useDraft();
  const setQuestionnaire = useQuestionnaire();

  useJobLocation();

  useEffect(() => {
    async function fetchData() {
      await getDraft();
      setIsLoading(false);
    }

    if (queryParamsDraftId) {
      if (isDataCleanupComplete && advertiserId) {
        fetchData();
      }
    } else {
      setIsLoading(false);
    }
  }, [
    advertiserId,
    dispatch,
    getDraft,
    isDataCleanupComplete,
    queryParamsDraftId,
  ]);

  // create questionnaire if questionnaireUrl not already saved in draft
  useEffect(() => {
    if (
      isDataCleanupComplete &&
      queryParamsDraftId &&
      hasDraftDataLoaded &&
      advertiserId &&
      seekAdvertiserId &&
      !questionnaireUrl
    ) {
      setQuestionnaire();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    advertiserId,
    seekAdvertiserId,
    hasDraftDataLoaded,
    isDataCleanupComplete,
    queryParamsDraftId,
    questionnaireUrl,
  ]);

  return { loading: isLoading };
};
